import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rectificados',
  templateUrl: './rectificados.component.html',
  styleUrls: ['./rectificados.component.css']
})
export class RectificadosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
